import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const SingleBedIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    {/* Top-down view: narrow bed, one pillow */}
    <rect x="7" y="2" width="10" height="20" rx="1.5" fill="currentColor" opacity={0.15} />
    <rect x="7" y="2" width="10" height="20" rx="1.5" fill="none" stroke="currentColor" strokeWidth="1.5" />
    <rect x="9" y="4" width="6" height="4" rx="1" fill="currentColor" opacity={0.5} />
  </SvgIcon>
);

export const DoubleBedIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    {/* Top-down view: wide bed, two pillows side by side */}
    <rect x="3" y="2" width="18" height="20" rx="1.5" fill="currentColor" opacity={0.15} />
    <rect x="3" y="2" width="18" height="20" rx="1.5" fill="none" stroke="currentColor" strokeWidth="1.5" />
    <rect x="5" y="4" width="6" height="4" rx="1" fill="currentColor" opacity={0.5} />
    <rect x="13" y="4" width="6" height="4" rx="1" fill="currentColor" opacity={0.5} />
  </SvgIcon>
);
